/**
 * Shipments CopilotKit Suggestions
 */

import { useMemo } from 'react'
import { useCopilotChatSuggestions } from '@copilotkit/react-ui'
import { useSelector } from '@ufc/core'
import { selectShipmentStats } from '../store/shipments.selectors'

export function useShipmentsSuggestions() {
  const stats = useSelector(selectShipmentStats)
  
  const instructions = useMemo(() => 
    `Shipment status: ${stats.loading} loading, ${stats.scheduled} scheduled, ${stats.delivered} delivered today.`,
    [stats]
  )

  useCopilotChatSuggestions({
    instructions,
    minSuggestions: 2,
    maxSuggestions: 3,
  })
}
